import React from "react";
import "./gallery.css";
import Header from "../../components/Header";
import HeaderImage from "../../images/header_bg_3.jpg";

const Gallery = () => {
  const gallerylength = 15;
  const image = [];
  for (let i = 1; i <= gallerylength; i++) {
    image.push(require(`../../images/gallery${i}.jpg`));
  }

  console.log(image);

  return (
    <>
      <Header title="Our Gallery" bredcum={HeaderImage}>
        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil velit
          molestias, pariamaxime voluptas conseqtetur eum.</p>
      </Header>

      <section className="gallery">
        <div className="container gallery__container">
          {
            image.map((image,index )=>{
              return(
                <article key={index}>
                  <img src={image} alt={`Gallery Image ${index+1}`}/>
                </article>
              )
            })
          }
        </div>
      </section>
    </>
  );
};

export default Gallery;
